<div>
  <div #cardElement></div>
  <button class="custom-btn custom-btn--primary xs-mt-20" (click)="handleSubscription()" [disabled]="isPaymentProcessing">
    <span>{{ isPaymentProcessing ? 'Processing...' : ('SUBSCRIPTION_PLANS.subscribe' | translate)}}</span>
  </button>
  <div *ngIf="errorMessage">{{ errorMessage }}</div>
</div>
